/* eslint-disable prefer-destructuring */
import { pr } from '@/utils/pxToRem';
import {
  Stack,
  Typography,
  TableContainer,
  Table,
  Paper,
  TableHead,
  TableBody,
  Button,
} from '@mui/material';
import {
  useRef,
} from 'react';
import { styled } from '@mui/system';
import { style } from '@/styles/globals';
import { useAppSelector } from '@/utils/hook';
import FlexTableRow from '@/components/FlexTableRow';
import WideTableCell from '@/components/WideTableCell';
import { convertThousand } from '@/utils/convertMoney';
import { lunarYear } from '@/utils/seoHelper';
import { getHostnameFromEnv } from '@/utils/getHostName';
import { ListAreasItem } from '@/slices/goyoloSeo/sliceType';

export const StyledButton = styled(Button)`
  border: 1px solid #858585;
  border-radius: 3px;
  transform: rotate(-180deg);
  width: 32px !important;
  height: 32px !important;
  min-width: 32px !important;
  color: #B8B8B8;
`;

interface SectionFamousRouteProps {
  onSelectTrip?: any;
  block: any;
}
export const TitleContent = styled('h4')`
  font-size: 20px;
  font-weight: 700;
  vertical-align: bottom;
  display: inline-block;
  margin-bottom: 16px;
  margin-top: 24px;
  line-height: 28px;
`;
export const TitleText = styled(Typography)`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 16px;
`;
const TableCel = ({ item, onSelectTrip, area }: any) => {
  const url = `https://${getHostnameFromEnv(process.env.APP_ENV || '')}/trip-detail?from=${area.startPoint.id}&to=${area.toPoint.id}&date[depart]=${item?.dateStr}&passenger%5Badt%5D=1&passenger%5Bchd%5D=0&passenger%5Binf%5D=0&fare_class=PT&flightId[depart]=${item?.id}` || '';
  const newUrl = `${process.env.VEX_URL}/vn/ve-may-bay/dat-ve-may-bay.vi?from=${area.startPoint.id}&to=${area.toPoint.id}&date[depart]=${item?.dateStr}&passenger[adt]=1&fare_class=PT&flightId[depart]=${item?.id || ''}`;

  return (
    <WideTableCell
      align="center"
      sx={{
        fontWeight: '500',
        color: style.primary.blue,
        minWidth: '93px',
        border: '1px solid #E0E0E0 !important',
        fontSize: '14px',
        lineHeight: '20px',
        textDecorationLine: 'underline',
        cursor: 'pointer',
      }}
    >
      {item?.averageMinfare ? (
        <a href={newUrl}>
          {`${convertThousand(Math.floor(item?.averageMinfare / 1000)).replace('.', '')}k`}
        </a>
      )
        : 'Đang cập nhật'}
    </WideTableCell>
  );
};
const Row = ({ item, onSelectTrip, dataRoute }: { item: ListAreasItem, onSelectTrip: any, dataRoute: any }) => (
  <FlexTableRow
    sx={{
      '&:last-child td, &:last-child th': { border: 0 },
      display: 'flex',
    }}
  >
    <WideTableCell
      sx={{
        minWidth: '140px',
        fontWeight: '400',
        color: style.neutral.black,
        border: '1px solid #E0E0E0 !important',
        background: '#fff',
        position: 'sticky',
        left: 0,
        fontSize: '14px',
        lineHeight: '20px',
      }}
    >
      {`${item.startPoint.stateName} - ${item.toPoint.stateName}`.replace('Hồ Chí Minh', 'Sài Gòn')}
    </WideTableCell>
    {(dataRoute?.daysInNewYears || []).map((row: any, i: number) => (
      <TableCel
        area={item}
        item={row}
        key={JSON.stringify(row)}
        onSelectTrip={onSelectTrip}
      />
    ))}
  </FlexTableRow>
);

const LunarNewYearAirfareByPolularRoute = ({
  onSelectTrip, block, tetData,
}: any) => {
  const tetDataObj = JSON.parse(tetData);
  const lunarNewYearAirfareByPolularRoute = tetDataObj.lunarNewYearAirfareByPolularRoute;
  const TableHeader = [
    '',
    '26 Tết',
    '27 Tết',
    '28 Tết',
    '29 Tết',
    '30 Tết',
    'Mùng 1 Tết',
    'Mùng 2 Tết',
    'Mùng 3 Tết',
    'Mùng 4 Tết',
  ];
  const refEl = useRef<any>();
  const title = `Giá vé máy bay ngày 26, 27, 28, 29, 30, mùng 1, mùng 2, mùng 3, mùng 4 Tết ${lunarYear}`;
  const goRight = () => {
    if (refEl && refEl.current) {
      refEl.current.scrollLeft -= 80;
    }
  };
  const goLeft = () => {
    if (refEl) {
      refEl.current.scrollLeft += 80;
    }
  };
  const listAreas = useAppSelector((state) => state.goyoloSeo.listAreas);
  return (
    <Stack
      sx={{
        minHeight: '50px',
        mt: '8px',
        boxShadow: 'none',
      }}
    >
      <TitleContent>
        {title}
      </TitleContent>
      <TitleText>Để đặt vé, bấm vào giá (đã bao gồm thuế, phí)</TitleText>
      <TableContainer
        component={Paper}
        sx={{
          minHeight: '50px',
          overflowX: 'auto',
          mt: '8px',
          boxShadow: 'none',
        }}
        ref={refEl}
      >
        <Table
          sx={{}}
          aria-label="simple table"
        >
          <TableHead>
            <FlexTableRow
              sx={{
                background: 'white',
                border: 0,
                display: 'flex',
              }}
            >
              <WideTableCell
                sx={{
                  background: '#F2F2F2',
                  minWidth: '140px',
                  color: style.neutral.black,
                  border: '1px solid #E0E0E0',
                  position: 'sticky',
                  left: 0,
                }}
                align="center"
              />
              {TableHeader.map((label: any, i: number) => {
                if (label) {
                  return (
                    <WideTableCell
                      key={label}
                      sx={{
                        ...(i === 0 ? { whiteSpace: 'nowrap' } : {}),
                        minWidth: '93px',
                        border: '1px solid #E0E0E0',
                        fontWeight: '500',
                        fontSize: '14px',
                        lineHight: '20px',
                      }}
                      align="center"
                    >
                      <div dangerouslySetInnerHTML={{ __html: label }} />
                    </WideTableCell>
                  );
                }
                return '';
              })}
            </FlexTableRow>
          </TableHead>
          <TableBody>
            {listAreas?.map((item, idx) => {
              const dataRoute = lunarNewYearAirfareByPolularRoute?.find((d: any) => d.route === `${item?.startPoint.id}-${item?.toPoint.id}`);
              return (
                <Row
                  onSelectTrip={onSelectTrip}
                  key={JSON.stringify(item)}
                  item={item}
                  dataRoute={dataRoute}
                />
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <Stack
        direction="row"
        justifyContent="flex-end"
        spacing={pr`12px`}
        sx={{
          marginRight: '24px',
          marginTop: '12px',
        }}
      >
        <StyledButton onClick={goRight}>
          {' '}
          {'>'}
          {' '}
        </StyledButton>
        <StyledButton onClick={goLeft}>
          {' '}
          {'<'}
          {' '}
        </StyledButton>
      </Stack>
    </Stack>
  );
};

export default LunarNewYearAirfareByPolularRoute;
